import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Eye } from 'lucide-react';
import { useStats } from '../contexts/StatsContext';
import { formatViews } from '../utils/formatViews';

const Footer = () => {
  const { t } = useTranslation();
  const { approvedCarsCount, totalViews, loading } = useStats();

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer__grid">
          <div>
            <h3>{t('footer.aboutTitle')}</h3>
            <p dangerouslySetInnerHTML={{ __html: t('footer.aboutText') }} />
            <div className="site-footer__meta">
              {loading ? (
                <span>{t('common.loading')}</span>
              ) : (
                <div className="site-footer__stats">
                  <span>{t('footer.stats', { count: approvedCarsCount })}</span>
                  <span className="site-footer__stats-sep" aria-hidden="true">·</span>
                  <span className="site-footer__views" title={t('footer.viewsHint')}>
                    <Eye size={14} strokeWidth={2.25} />
                    {t('footer.viewsStats', { count: formatViews(totalViews) })}
                  </span>
                </div>
              )}
              <span>{t('footer.workingHours')}</span>
            </div>
          </div>

          <div>
            <h3>{t('footer.followTitle')}</h3>
            <p>{t('footer.followText')}</p>
            <a
              href="https://t.me/avto_tarix_uz"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
              style={{ marginTop: 16 }}
            >
              {t('footer.subscribeButton')}
            </a>
          </div>

          <div>
            <h3>{t('footer.importantTitle')}</h3>
            <p>{t('footer.importantText')}</p>
            <p style={{ marginTop: 16 }}>
              <Link to="/reklama" style={{ color: 'var(--ink)', fontWeight: 600 }}>
                Reklama / Advertising →
              </Link>
            </p>
          </div>
        </div>

        <div className="site-footer__copy">{t('footer.copyright')}</div>
      </div>
    </footer>
  );
};

export default Footer;
